export const SHOW_LOGIN = 'SHOW_LOGIN';
export const HIDE_LOGIN = 'HIDE_LOGIN';
export const SIGN_IN = 'SIGN_IN';
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS';
export const SIGN_IN_ERROR = 'SIGN_IN_ERROR';
export const SIGN_OUT = 'SIGN_OUT';
export const SIGN_VALIDATE_TOKEN = 'SIGN_VALIDATE_TOKEN';
export const SIGN_LOADING = 'SIGN_LOADING';
export const GLOBAL_START_LOADING = 'GLOBAL_START_LOADING';
export const GLOBAL_STOP_LOADING = 'GLOBAL_STOP_LOADING';
